import React from 'react';
import cx from 'classnames';
import Helmet from 'react-helmet';
import Nav from '../Nav';
import SEO from '../SEO';
import config from '../../../data/SiteConfig';
import './index.css';

const Layout = React.forwardRef(
  (
    {
      children,
      titleTemplate,
      title,
      description,
      twitter,
      className,
      permalink,
    },
    ref
  ) => {
    const usedTitle = titleTemplate
      ? titleTemplate.replace('%s', title)
      : title;
    return (
      <div
        ref={ref}
        className={cx(
          'center padding-top-2-dot-75-rem padding-bottom-6-rem',
          className
        )}
      >
        <SEO {...{ title: usedTitle, description, permalink }} />
        <Nav />
        <br />
        {children}
      </div>
    );
  }
);

export default Layout;
